module.exports = __webpack_public_path__ + "static/media/W.d87ed558.png";